export const sendBlobAsLink = (fileName, data) =>
    new Promise((resolve, reject) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        resolve(fileName)
    })

export const printBlob = (data) =>
    new Promise((resolve, reject) => {
        var blob = new Blob([data], { type: 'application/pdf' })
        const blobUrl = URL.createObjectURL(blob)
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = blobUrl
        document.body.appendChild(iframe)

        // Hack para la impresion en Firefox.
        // Sin el timeout imprime el iframe antes que esté cargado lo que resulta en una pagina en blanco
        setTimeout(function () {
            iframe.contentWindow.print()
        }, 500)

        resolve()
    })
